import { render, staticRenderFns } from "./ViewPayPlanChangeRequestLegacy.vue?vue&type=template&id=c14a9326"
import script from "./ViewPayPlanChangeRequestLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewPayPlanChangeRequestLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports